import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WidgetsQuestionModel } from 'src/app/models/widgets/widgets-question.model';

@Injectable({
    providedIn: 'root'
})
export class QuestionPreviewService {
  private booleanValue = new BehaviorSubject(false);
  // castValue used to toggle preview dialog (show = true , hide = false)  
  castValue = this.booleanValue.asObservable();
  // data used for preview Question data transfer
  // data: WidgetsQuestionModel = new WidgetsQuestionModel();

  private readonly _questionRoot = new BehaviorSubject<WidgetsQuestionModel>(new WidgetsQuestionModel());
  public readonly questionRoot$ = this._questionRoot.asObservable();

  /**
   * Getter for root Layout
   *
   * @returns Current value of the WidgetsFormModel layout
   */
  get data(): WidgetsQuestionModel {
    return this._questionRoot.getValue();
  }

  /**
   * Setter for root Layout
   *
   * @param form New Form to be the root layout will be
   */
  set data(form: WidgetsQuestionModel) {
    this._questionRoot.next(form);
  }
 
  sendValue(newValue){
    // booleanValue used to toggle preview dialog (show = true , hide = false)  
    this.booleanValue.next(newValue); 
  }
}